<template>
  <section class="opponent-found">
    <div class="opponent-found__vs"><span>VS</span></div>
    <div class="opponent-found__item opponent-found__item--left">
      <img :src="playersDetails.homePlayerAvatar" alt="" class="opponent-found__item__avatar">
      <span class="opponent-found__item__name">{{ playersDetails.homePlayerUsername }}</span>
      <span class="opponent-found__item__level">{{ getTranslations.home_opponent_found_level }} {{ playersDetails.homePlayerLevel }}</span>
    </div>
    <div class="opponent-found__item opponent-found__item--right">
      <img :src="playersDetails.awayPlayerAvatar" alt="" class="opponent-found__item__avatar">
      <span class="opponent-found__item__name">{{ playersDetails.awayPlayerUsername }}</span>
      <span class="opponent-found__item__level">{{ getTranslations.home_opponent_found_level }} {{ playersDetails.awayPlayerLevel }}</span>
    </div>
  </section>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapGetters, mapMutations } from 'vuex';
import webSocket from '@/common/webSocket';
import { opponentFoundVSText } from '@/common/jQuery';
import { ParseResponseMixin, GameMixin2, GameMixin3 } from '@/common/mixins/game';

export default {
  name: 'opponent-found',
  mixins: [ParseResponseMixin, GameMixin2, GameMixin3],
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (!this.stompClient.connected) this.OnStompClientFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      stompClient: null,
      subscription: null,
    };
  },
  created() {
    // console.clear();
    this.stompClient = webSocket.getGameStompClient();
    console.log('this.stompClient:', this.stompClient);
    this.getCTAs();
  },
  mounted() {
    console.log('in OpponentFound mounted hook');
    console.log('this.playersDetails:', this.playersDetails);
    opponentFoundVSText();
  },
  methods: {
    ...mapMutations('game', [
      'setPlayersCurrentQuestionDTOs',
      'setPlayersHelpsUsedStatus',
    ]),
    OnStompClientFailure(error) {
      console.log(error);
      window.location.reload();
    },
    getCTAs() {
      console.log(`Subscribing to channel: /topic/ctasFetched/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/ctasFetched/${this.gameID}`, (response) => {
        this.subscription.unsubscribe();
        console.log('[SelectedTheme] Inside ctasFetched response');
        // parse server response and return if any errors occur
        const responseBody = this.parseServerResponse(response.body);
        if (responseBody === null) {
          return;
        }
        const responseData = responseBody.gameDTO;
        console.log('responseData:', responseData);
        if (responseData.gameStateEnum === 'CTA_TO_BE_ANSWERED') {
          this.setPlayersCurrentQuestionDTOs({
            homePlayerQuestionDTO: responseData.homeUserDetails.questionDTO,
            awayPlayerQuestionDTO: responseData.awayUserDetails.questionDTO,
          });
          this.setPlayersHelpsUsedStatus({
            homePlayerCheatHelpUsed: responseData.homeUserDetails.cheatUsed,
            homePlayerFiftyFiftyHelpUsed: responseData.homeUserDetails.fiftyFiftyUsed,
            awayPlayerCheatHelpUsed: responseData.awayUserDetails.cheatUsed,
            awayPlayerFiftyFiftyHelpUsed: responseData.awayUserDetails.fiftyFiftyUsed,
          });
          this.normalTransition = true;
          console.log('going to game page');
          this.$router.replace('/game');
        }
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameID',
      'currentRoundNumber',
      'homePlayerCurrentSelectedTheme',
      'awayPlayerCurrentSelectedTheme',
      'playersDetails',

    ]),
    ...mapGetters('game', [
      'isHomePlayer',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/OpponentFound.vue